"use client";
import React, { useEffect, useState } from "react";
import { getBestSellersProducts } from "@/src/models/products";
import ProductList from "../components/ProductInTable/ProductList";
import { useProductDetailsContext } from "@/src/provider";
import { ProductInTable } from "../components";

interface Props {}

const H5HotClient: React.FC<React.PropsWithChildren<Props>> = (props) => {
    const [bestList, setBestList] = useState<any>([]);
    const [fetchedProducts, setFetchedProducts] = useState(false);
    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);
    useEffect(() => {
        //获取热销产品
        getBestSellersProducts(productDetail.products_id!).then((data) => {
            setBestList(data);
            setFetchedProducts(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ProductInTable>
            <></>
            {props.children}
            <ProductList
                fetchedProducts={fetchedProducts}
                data={bestList ? bestList.slice(0, 4) : []}
                type={"hot"}
            />
        </ProductInTable>
    );
};

export default H5HotClient;
